module.exports = __webpack_public_path__ + "static/Fellix-Medium-db8deebd7eda3fd6ac260d2f240cc574.woff";